import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorSocial } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorSocial;
};
